import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { TimePicker } from 'antd';

import { observacioModificarDataHoraFormulari } from '../../actions';
import { convertirTextAMomentUTC, MASCARA_YYYYMMDD } from '../../commons/gestioDates';
import moment from 'moment';

const MASCARA_HORA_VISUALITZAR_TIMEPICKER = 'HH:mm';

class ObservacioIntroduccioHoraObservacio extends Component {

    constructor(props) {
        super(props);
        this.onChangeTimePickerDataHoraObservacio = this.onChangeTimePickerDataHoraObservacio.bind(this);
    }

    /**
     * Retorna una data amb el dia del formulari i l'hora seleccionada
     *
     * @param dataText {String}
     * @param hora {Number}
     * @param minuts {Number}
     * @return data {Moment}
     */
    obtenirDataHoraFormulari(dataText, hora, minuts) {
        let data = convertirTextAMomentUTC(dataText, MASCARA_YYYYMMDD);
        data.hours(hora);
        data.minutes(minuts);
        return data;
    }

    /**
     *
     * @param time {Moment}
     */
    onChangeTimePickerDataHoraObservacio(time = null) {
        const dataFormulariText = this.props.dataSeleccionada;
        const dataFormulari = time ? this.obtenirDataHoraFormulari(dataFormulariText, time.hours(), time.minutes()) : null;
        this.props.observacioModificarDataHoraFormulari(dataFormulari);
    }

    minutsDeshabilitats() {
        let totsElsMinuts = Array.from(Array(60).keys());
        let minutsValids = [0, 15, 30, 45];
        return totsElsMinuts.filter(minut => !minutsValids.includes(minut));
    }

    render() {

        const dataHoraObservacioObjecte = this.props.dataHoraObservacio;

        let dataHoraObservacioMostrar;
        let dataHoraObservacioMostrarText;

        if (dataHoraObservacioObjecte.hasOwnProperty('dataHoraObservacioNou')) {
            dataHoraObservacioMostrarText = dataHoraObservacioObjecte.dataHoraObservacioNou;
        } else if (dataHoraObservacioObjecte.hasOwnProperty('dataHoraObservacio')) {
            dataHoraObservacioMostrarText = dataHoraObservacioObjecte.dataHoraObservacio;
        }

        dataHoraObservacioMostrar = dataHoraObservacioMostrarText ? convertirTextAMomentUTC(dataHoraObservacioMostrarText) : null;

        return (
            <div className='observacio-introduccio-hora'>
                <span>{'Hora:'}</span> 
                <TimePicker
                    disabledMinutes={this.minutsDeshabilitats}
                    hideDisabledOptions
                    value={dataHoraObservacioMostrar}
                    defaultOpenValue={moment.utc('00:00', MASCARA_HORA_VISUALITZAR_TIMEPICKER)}
                    format={MASCARA_HORA_VISUALITZAR_TIMEPICKER}
                    placeholder={MASCARA_HORA_VISUALITZAR_TIMEPICKER}
                    onChange={this.onChangeTimePickerDataHoraObservacio}
                    className='observacio-introduccio-hora-observacio-timepicker'
                />UTC
            </div>
        );
    }
}

ObservacioIntroduccioHoraObservacio.propTypes = {
    dataSeleccionada: PropTypes.string,
    dataHoraObservacio: PropTypes.object,
    observacioModificarDataHoraFormulari: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        observacioModificarDataHoraFormulari,
    }, dispatch);
};

export default connect(null, mapDispatchToProps)(ObservacioIntroduccioHoraObservacio);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioHoraObservacio.js